import * as types from '../actions/ActionTypes';

const INITIAL_STATE = {
  visible: false
};

export function dialogReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_DIALOG_VISIBILITY:
      return {
        ...state,
        data: action.payload.data,
        visible: action.payload.visibility
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dialog.reducer.js